import * as angular from "angular";
import {IController} from "angular";

export class MinimizedPanelsCtrl implements IController {
  public PANEL_TABS = {
    SERVICES: 0,
    ROUTES: 1,
    RESOURCES: 2
  };
}

angular
  .module('bringoz.admin.planning')
  .component('minimizedPanels', {
    bindings: {
      visibleMinimizedPanels: '<',
      minimizedPanels: '<',
      visibleMinimizedPanelsCount: '<',
      invisibleMinimizedPanels: '<',
      jobs: '<',
      routes: '<',
      resources: '<',
      siteFiltersType: '<',
      isMorePanelsDropdownOpen: '<',
      onMaximizePanel: '&',
      onClosePanel: '&',
      getRouteColor: '&',
      getRouteServicesCount: '&',
      panelHasFilters: '&',
      onToggleMorePanelsDropdown: '&',
      onCloseHiddenMinimizedPanels: '&'
    },
    template: require('./minimized-panels.html').default,
    controller: MinimizedPanelsCtrl
  });
